import { Component, OnInit } from "@angular/core";

@Component({
  selector: "wait-for-payment",
  template: `
    <div class="w-full h-full flex flex-row justify-center items-center">
      <div
        class="relative flex flex-col justify-center items-center"
        style="max-width: 90vw;"
      >
        <h2 class="mb-4 text-2xl font-semibold text-center">{{ mainText }}</h2>
        <div class="ml-8">
          <app-spinner></app-spinner>
        </div>
        <div class="font-normal mt-4 w-full text-center">{{ stageText }}</div>
      </div>
    </div>
  `,
  styleUrls: ["./wait-for-payment.component.scss"],
})
export class WaitForPaymentComponent implements OnInit {
  public mainText =
    "נא לא לצאת / לרענן את הדף, יש לחכות עד קבלת אישור בהודעה במסך";
  public stageText = "";
  private stagesText = [
    "מתחבר לשירות התשלומים...",
    "ממתין לאישור התשלום...",
    "מעבד את התשלום...",
    "מאשר את התשלום...",
    "מסיים...",
  ];

  constructor() {}
  public ngOnInit() {
    let stageIndex = 0;
    const stageInterval = setInterval(() => {
      if (stageIndex < this.stagesText.length) {
        this.stageText = this.stagesText[stageIndex];
        stageIndex++;
      }
    }, 3000);
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/wait-for-payment/wait-for-payment.component.ts